import { LoginService } from '@services/login.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs/operators';
import { ConfigService } from '@services/config.service';
import { ParametroSistemaService } from '@services/parametro-sistema.service';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { VtToasterComponent } from './components/vt-toaster/vt-toaster.component';
import { RouterOutlet } from '@angular/router';
import { FileDownloadComponent } from './components/file-download/file-download.component';

declare function createSoluCXWidget(p1: any, p2: any, p3: any, p4: any): void;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgxSpinnerComponent, VtToasterComponent, RouterOutlet, FileDownloadComponent]
})

export class AppComponent implements OnInit {
  [x: string]: any;
  title = 'alelo';
  public api_token: any;
  public client;
  public widgetObj: any;

  constructor(private readonly configService: ConfigService,
              private readonly parametroSistemaService: ParametroSistemaService) { }

  ngOnInit(): void {

    this.loadConfig();

    LoginService.events$.subscribe((e) => {
      switch (e.type) {
        case 'logout':
          ['solucxWrapper', 'neoFrame'].forEach((id) => {
            const elemento = document.getElementById(id);
            if (elemento) {
              elemento.remove();
            }
          });
          break;

        case 'login success':
          this.chatBot();
          break;
      }
    });
  }


  loadConfig() {
    this.api_token = this.configService.getConfig().API_TOKEN_SEARCH;
  }

  chatBot() {
    this.parametroSistemaService.getParametroSistema('URL_CHATBOT')
      .pipe(take(1))
      .subscribe((response: any) => sessionStorage.urlChatBot = response.response);
  }
}
